import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { TextField } from '../../components/ui/Field';
import { ChoiceChip } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { useCopy } from '../../contexts/LanguageContext';
import type { StepProps } from '../../types/quiz';
export function StepChildName({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  const step = copy.steps.name;
  const canContinue = profile.child_name.trim().length > 0 && profile.child_gender !== '';
  return <div className="flex flex-1 flex-col" data-id="element-108" data-mp="1b6f2h7im1cav">
      <Headline data-id="element-109" data-mp="1b5ng8nawkqx9">{step.headline}</Headline>
      <Subtext data-id="element-110" data-mp="1b4km86iaa8d4">{step.subtext}</Subtext>

      <div className="mt-6" data-id="element-111" data-mp="1g4qbxh4ztksk">
        <TextField id="child-name" label={step.label} value={profile.child_name} onChange={value => update({
        child_name: value
      })} placeholder={step.placeholder} data-id="element-112" data-mp="1g3x74lplh5d2" />
      </div>

      <fieldset className="mt-8" data-id="element-113" data-mp="3cuzobeygqw3p">
        <legend className="font-display text-xl font-semibold text-ink" data-id="element-114" data-mp="3cw1b2goud719">
          {step.genderLegend}
        </legend>
        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-115" data-mp="37xg8iam4ab9n">
          <ChoiceChip emoji="💙" label={step.son} selected={profile.child_gender === 'son'} onSelect={() => update({
          child_gender: 'son'
        })} data-id="element-116" data-mp="3mkj94q5ql017" />
          <ChoiceChip emoji="💗" label={step.daughter} selected={profile.child_gender === 'daughter'} onSelect={() => update({
          child_gender: 'daughter'
        })} data-id="element-117" data-mp="3vky4yjgbtxiy" />
        </div>
      </fieldset>

      <div className="mt-auto pt-10" data-id="element-118" data-mp="9dr9l3z18cd7">
        <PrimaryButton onClick={onNext} disabled={!canContinue} data-id="element-119" data-mp="4f6efiyn0ivm">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}